import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var MusicNotePlus = function MusicNotePlus(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M14.5 18V5.5889c0-.8572 0-1.2858.1805-1.544a1 1 0 0 1 .6733-.4161c.3117-.046.695.1456 1.4617.529L20.5 6m-6 12c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3432 3 3m-8-8V4m-3 3h6"
    })
  }));
};
export default MusicNotePlus;